/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('theme:variant:change', function(event) {
    var section = event.target;
    var block = section && section.querySelector('[data-product-upsell-block]');

    if (!block) {
      return;
    }

    var holder = block.querySelector('[data-product-upsell-items]');
    var title = block.querySelector('[data-product-upsell-title]');
    var variant = event.detail && event.detail.variant;
    var source = null;

    if (!holder) {
      return;
    }

    if (variant) {
      source = block.querySelector('[data-product-upsell-variant="' + variant.id + '"]');
    }

    if (!source) {
      source = block.querySelector('[data-product-upsell-default]');
    }

    var html = source ? source.innerHTML : '';
    var hasUpsells = html.trim() !== '';

    holder.innerHTML = html;
    block.hidden = !hasUpsells;

    if (title) {
      title.hidden = !hasUpsells;
    }
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
